var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBettermapsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 523.68 112.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4,.cls-5{fill:#fff;}.cls-1{opacity:0.19;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}.cls-3{opacity:0.18;}.cls-4,.cls-5{font-size:98.7px;}.cls-4{font-family:Roboto-Medium, Roboto;font-weight:500;}.cls-5{font-family:Roboto-Light, Roboto;font-weight:300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "292.31 71.86 304.33 27.3 304.33 27.3 318.43 35.87 318.43 35.87 316.35 84.43 292.31 71.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "289.95 36.53 270.8 82.83 292.71 71.72 270.8 82.83 290.97 34.39 304.73 27.17 318.83 35.73 333.26 27.3 347.63 34.79 366.88 85.24 343.45 77.28 316.75 84.3 292.71 71.72 316.75 84.3 343.45 77.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "333.26 27.3 343.45 77.28 366.88 85.24 347.63 34.79 333.26 27.3"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 84.43)"
  }, "better"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(366.14 85.52)"
  }, "aps")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBettermapsWhite);
export default __webpack_public_path__ + "static/media/BettermapsWhite.0e4f9c7f.svg";
export { ForwardRef as ReactComponent };